// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1CRcl","rootSmall":"AddTileButton_rootSmall__16eDp"};